import { set, toggle } from "@/utils/vuex";

export default {
    setDrawer: set("drawer"),
    setImage: set("image"),
    setColor: set("color"),
    toggleDrawer: toggle("drawer"),

    setDataTable(state, table) {
        if (state.dataTables.some((t) => t.url == table.url)) {
            const savedTable = state.dataTables.find((t) => t.url == table.url);

            savedTable.filters = table.filters;
            savedTable.filterTypes = table.filterTypes;
            savedTable.sort = table.sort;
            savedTable.page = table.page;

            return;
        }

        state.dataTables.push(table);
    },
    clearDateTables(state) {
        state.dataTables = [];
    },
    setAccountMessageListner(state, accountID) {
        state.accountMessageListner = accountID;
    },
};
